import { render, staticRenderFns } from "./ServidorPV.vue?vue&type=template&id=426605f3"
import script from "./ServidorPV.vue?vue&type=script&lang=js"
export * from "./ServidorPV.vue?vue&type=script&lang=js"
import style0 from "./ServidorPV.vue?vue&type=style&index=0&id=426605f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports